<template>
  <div>
    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div style="padding-top: 77px;">
              <h2 class="listing-page-title">Retrieve Your Policy</h2>
              <p class="listing-page-desc">Insurance <span style="color:var(--secondary-color);">Bazaar</span></p>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container article-box">
        <div class="row">
          <div class="col-12">
            <form v-on:submit="RetrievePolicy">
                <div class="row">
                    <div class="col-md-6">
                    <label class="label-d-block">Passport Number</label>
                    <div class="jbl-field">
                        <input class="jbl-dynamic-input" v-model="passportNumber" type="text" placeholder="Enter Passport Number" required>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <label class="label-d-block">Departure Date</label>
                    <div class="jbl-field">
                      <datepicker initial-view="year" class="jbl-dynamic-input" v-model="departureDate" format="dd-MMM-yyyy" placeholder="DD-MM-YYYY" input-class="jbl-generated-input" calendar-class="jbl-calendar" required></datepicker>
                    </div>
                    </div>
                    <div class="col-md-6">
                    <label class="label-d-block">Name</label>
                    <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" v-model="name" placeholder="Enter Your Name">
                    </div>
                    </div>
                    <div class="col-md-6">
                    <label class="label-d-block">Policy Number</label>
                    <div class="jbl-field">
                        <input class="jbl-dynamic-input" type="text" v-model="policyNumber" placeholder="Enter Policy Number" required>
                    </div>
                    </div>
                </div>
                <div class="my-3 mx-auto text-center">
                    <button type="submit" class="ib-btn-primary ib-btn-width">Submit</button>
                </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment';
  import loading from '@/components/Loading/Loading';

  export default {
    name: "RetrievePolicy",
    data() {
      return {
        showLoader: false,
        passportNumber: '',
        departureDate: '',
        name: '',
        policyNumber: '',
      };
    },
    components: {
      loading,
      Datepicker
    },
    created() {
      const self = this;
      let uri = window.location.search.substring(1);
      let params = new URLSearchParams(uri);
      self.passportNumber = params.get("passport_no");
      self.departureDate = self.formatDBDate(params.get("departure_date"), 'field');
      self.policyNumber = params.get("policy_no");
    },
    computed: {
      issueDate () {
        return moment().format('YYYY-MM-DD');
      }
    },
    methods: {
      formatDBDate (dbDate, type) {
        if(dbDate == '' || dbDate == null || dbDate == undefined) {
          return '';
        } else {
          if(type == 'field') {
            var parts = dbDate.split('-'); //'20-04-2021'
            var newDate = new Date(parts[0], parts[1] -1, parts[2]);
          }
          if(type == 'beneficiary') {
            var parts = dbDate.split('-'); //'2021-04-20'
            var newDate = new Date(parts[0], parts[1] -1, parts[2]);
          }
          //let newDate = new Date(Date.parse(dbDate));
          let date = newDate.getDate();
          let month = newDate.getMonth() + 1;
          let year = Math.abs(newDate.getFullYear());
          let newDateString = month + '-' + date + '-' + year;
          let selectedDate = moment(newDateString, "M-D-YYYY").toDate();
          return selectedDate;
        }
      },
      RetrievePolicy: function (e){
        e.preventDefault();
        const self = this;
        if (self.departureDate == ''){
          $toast.error('Please Select Departure Date', { position: 'top-right' });
          return false;
        }
        let formData = new FormData();
        formData.append('passport_number', self.passportNumber);
        formData.append('departure_date', moment(self.departureDate).format("YYYY-MM-DD"));
        formData.append('policy_no', self.policyNumber);
        formData.append('name', self.name);

        axios.post('retreive_policy_doc', formData).then(function (resp) {
          if (resp.data.code == 200){
            window.location.href = resp.data.data.policy_doc_link;
          }else{
            $toast.error(resp.data.message, { position: 'top-right' });
          }
        }).catch((error) => {
          self.showLoader = false;
          if(error.response.data.errors != undefined) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.response.data, { position: 'top-right' });
          }
          return false;
        });
      }
    }
  };
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/views/RetrievePolicy.vue